import { Component, OnInit, OnDestroy, ElementRef, Renderer2, ViewChild, AfterViewInit, Injector } from "@angular/core";
import { FormGroup, Validators, FormBuilder, FormControl } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "../services/common.service";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ActivatedRoute } from "@angular/router";
import { Observable, Subscription, concat, Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";
import { TabChangeService } from "../services/tab-change.service";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { ChangeDetectorRef } from '@angular/core';
import { COMMA, ENTER, V } from "@angular/cdk/keycodes";
import { MatMenuTrigger } from "@angular/material/menu";
import { CaseauditComponent } from "./caseaudit/caseaudit.component";
import { CaseinfoComponent } from "./caseinfo/caseinfo.component";
import { CasespecimenComponent } from "./casespecimen/casespecimen.component";
import { CasemessageComponent } from "./casemessage/casemessage.component";
import { CasehistoryComponent } from "./casehistory/casehistory.component";
import { OtherinfoComponent } from "./otherinfo/otherinfo.component";
import { CaseclaimComponent } from "./caseclaim/caseclaim.component";
import { NewauditComponent } from "../newaudit/newaudit.component";

export class Filter {
  constructor(public name: string) { }
}
@Component({
  selector: "app-case360",
  templateUrl: "./case360.component.html",
  styleUrls: ["./case360.component.scss"],
})
export class Case360Component implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tomailInput', { static: false }) tomailInput: ElementRef<HTMLInputElement>;
  @ViewChild(MatMenuTrigger, { static: false }) menuTrigger: MatMenuTrigger;
  selectedTab: string ='';
  UpdateSubscript: Subscription;
  
  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'case 360 prime';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];
  private modalRefsTracked: Array<{ ref: any, windowClass: string }> = [];

  private trackModalRef(modalRef: any, windowClass: string = '') {
    this.currentModalRefs.push(modalRef);
    this.modalRefsTracked.push({ ref: modalRef, windowClass });
  }

  private untrackModalRef(modalRef: any) {
    this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    this.modalRefsTracked = this.modalRefsTracked.filter(m => m.ref !== modalRef);
  }

  searchParameterInfo: boolean = true;
  searchcaseText: any = "";
  searchDeployement: any;
  caseDataList = [];
  caseDataListBackup = {};
  caseDataListCard: unknown = [];
  caseTabsList:any[]=['Case Info','Specimen Details','Messages','Patient History','Other Info','Case Claims','Case Audit'];
  caseInfo: any;
  caseInfoDetails: any;
  requisitionNumberData: object = {};
  CaseList: any[] = [];
  showDetailsCase: boolean = false;
  patientHistory: any[] = [];
  encryptedurl: any = "";
  auditData: any;
  isEnablesso: any;
  encryptagentid: string = "";
  filterFieldsList: any[] = [];
  searchTerm: string[] = [];
  Filtervalue: string[] = [];
  deploymentItemsList = [];
  searchForm!: FormGroup;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  formValue: any;
  searchTermData: string[] = [];
  splitvalue: string[] = [];
  FormName: any;

  addOption: Filter;
  showForm = false;
  searchControl = new FormControl();
  submitted: any;
  responseData: any;
  control = new FormControl();
  //searchOptions:any
  DeploymentKey: string = "DeploymentKey";
  public reactiveFormdeployment: FormGroup;
  deploymentSelected: string = '';

  searchOptions: Filter[] = [];
  searchOptionslist: Filter[] = [];
  selectedDeploymentKey: any;
  searchFormKey: Filter[];
  searchfieldName: any[];
  filteredOptions: Observable<Filter[]> | undefined;
  keyword = 'name';
  oldFiltervalue: string[];
  oldSearchValue: string[];
  inputdata:any;
  islabadmin:boolean;
  isadmin3:boolean;
  today = new Date();
  constructor(
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
    private renderer: Renderer2,
    public service: CommonService,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private ngxUiLoaderService: NgxUiLoaderService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private injector: Injector,
    private tabChangeService: TabChangeService
  ) {
    this.route.queryParams.subscribe((params) => {
      if (params.Input != undefined && params.Input != "") {
        this.encryptedurl = params.Input;
        this.encryptagentid = params.EncryptID;
        this.service.updatessoStatus(true);
      }
    });
    this.reactiveFormdeployment = this._formBuilder.group({ deploymentname: ['', Validators.required] });
    this.searchForm = this._formBuilder.group({});
    if(sessionStorage.getItem("SelectedUserRole")=='LabAdminCase360'){
      this.islabadmin=true;
    }else if(sessionStorage.getItem("SelectedUserRole").toLowerCase()=='admin3'){
      this.isadmin3=true;
    }
  }



   ngOnInit() {
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    
    this.searchControl.reset();
    this.UpdateSubscript = this.service.UpdatedXmlData.subscribe((data) => {
      ;
      if (data !== "") {
        this.showCaseData(JSON.parse(data));
        setTimeout(() => {
          this.selectedTab = 'Case Audit';
        })
      }
    });

    this.getDeployments();

    this.getSearchOptions();

    this.service.msgtocase360_2$.subscribe((data) => {
      if (data !== "") {
        this.getDeployments();
        this.getSearchOptions();
        this.Filtervalue=[];
        this.searchControl.reset();
        this.searchForm.reset();
        let obj =JSON.parse(data);
        this.ngxUiLoaderService.start();
        this.service.getlookupInfo('Case360key').subscribe((data)=>{
          this.ngxUiLoaderService.stop();
          if(data.length>0){
            obj.type=data.find(V=>V.lookupid==obj.type).lookupvalue;
            let matkey=this.searchOptionslist.find(V=>V.name.toLowerCase().includes(obj.type.toLowerCase()));
            let searchchip={
              value:matkey.name +obj.value};
            this.addtoFilterForm(searchchip);
            this.deploymentSelected=this.deploymentItemsList.find(V=>V.toLowerCase()==obj.dkey.toLowerCase());
            this.reactiveFormdeployment.patchValue({ "deploymentname": this.deploymentSelected });
            this.submitSearch();
          }
        });
      }
    });

    if (
      this.encryptedurl !== "" &&
      this.encryptedurl != undefined &&
      this.encryptedurl !== "{}"
    ) {
      this.submitSearch();
    }

  }
  ngAfterViewInit() {
    if (this.tomailInput) {
      this.tomailInput.nativeElement.value = '';
    }
    this.setOverflowClass();
  }
  private waitForViewInit(): Promise<void> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      });
    });
  }

  getDeployments() {
    this.service.getDeployments("Deployments").subscribe(
      (data) => {
        if (data.length > 0) {
          this.deploymentItemsList = data;
        } else if (data.length === 0) {
          this.deploymentItemsList = [];
        }
      },
      (error) => {
        this.toastr.error("Something went wrong", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    );
  }

  getSearchOptions() {
    this.service.getCase360Parameter().subscribe(
      (data: any[]) => {
        if (data.length > 0) {
          this.searchFormKey = data.map((item: any) => new Filter(item.lookupvalue));
          this.searchfieldName = data.map((item: any) => (item.lookupvalue.replace('#date#', '') + ':' + item.lookupid));
          this.searchOptions = data
            .filter(item => item.lookupvalue.toLowerCase() !== 'deploymentkey') // Filter out items with lookupvalue 'DeploymentKey'
            .map((item: any) => new Filter(item.lookupvalue.replace('#date#', '') + ':'));
          this.filteredOptions = this.searchControl.valueChanges
            .pipe(
              startWith(''),
              map(search => (search && typeof search === 'object') ? search.name : search),
              map((name: string) => name ? this.filter(name) : this.searchOptions.slice())
            );
          this.searchOptionslist = JSON.parse(JSON.stringify(this.searchOptions));
          data.forEach((item: any) => {
            if (item.lookupvalue.trim().toLowerCase() !== 'deploymentkey') { // Check if lookupvalue is not 'DeploymentKey'
              const controlName = item.lookupvalue.replace('#date#', ''); // Get the lookupvalue as the control name
              this.searchForm.addControl(controlName, new FormControl('', Validators.required));
            }
          });
        } else {
          this.searchOptions = [];
          this.toastr.error("Failed to get search params", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      },
      (error) => {
        this.toastr.error("Something went wrong", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    );
  }

  setOverflowClass() {
    let input: HTMLInputElement
    if (this.tomailInput) {
      input = this.tomailInput.nativeElement;
      input.addEventListener('input', () => {
        this.isInputOverflowed(input);
      });
    }
  }

  isInputOverflowed(input: HTMLInputElement): boolean {
    return input.scrollWidth > input.offsetWidth;
  }

  showCaseData(data) {
    this.ngxUiLoaderService.start();
    this.tabComponentCache.clear();
    this.loadedTabs.clear();
    if (data !== "" && data !== undefined) {
     
      this.service.CaseDataDetails = data;
      this.caseInfo = JSON.parse(data.casedata);
      this.caseInfoDetails = this.caseInfo["Case"];
      this.caseInfoDetails['RequisitionNumber'] = data.ReqNumber;
      this.caseInfo = {
        ...this.caseInfo,
        DeploymentKey: data.deploymentKey,
      };
      this.auditData = {
        deploymentKey: data.deploymentKey,
        CaseGUID: this.caseInfoDetails.CaseGUID,
        AccessionNumber:data.caseInfoDetails.AccessionNumber,
        RequisitionNumber:data.ReqNumber
      };

      this.caseInfoDetails = {
        ...this.caseInfoDetails,
        DeploymentKey: data.deploymentKey,
      };
      console.log(this.caseInfoDetails);
      if (this.caseInfoDetails.PatientHistoryDetails !== undefined &&
        Array.isArray(this.caseInfoDetails.PatientHistoryDetails.PatientHistory)
      ) {
        this.patientHistory =
          this.caseInfoDetails.PatientHistoryDetails.PatientHistory;
      } else if (this.caseInfoDetails.PatientHistoryDetails !== undefined) {
        this.patientHistory = [
          this.caseInfoDetails.PatientHistoryDetails.PatientHistory,
        ];
      } else {
        this.patientHistory = []
      }
      let obj = {
        ReqNumber: data.ReqNumber,
        DeploymentKey: data.deploymentKey,
        caseid: data.caseid,
        accessionnumber: data.caseInfoDetails.AccessionNumber,
        caseguid: data.caseInfoDetails.CaseGUID
        // "laborgid":data.laborgid,
        // "labaccountid":data.labaccountid
      };

      this.requisitionNumberData = obj;
      this.caseDataList;
      this.searchDeployement = data.deploymentKey;
    }
    setTimeout(()=>{
       this.showDetailsCase = true;
       let obj={
        index:0
       }
       this.onTabChanged(obj);
       this.ngxUiLoaderService.stop();
    },2000)
    
  }

  getlabName(caseInfoDetails) {
    if (caseInfoDetails !== undefined) {
      if (Array.isArray(caseInfoDetails["ServiceProvider"])) {
        let labs = caseInfoDetails["ServiceProvider"].filter(
          (va) => va.Location.AccountType === "Laboratory"
        );
        if (labs.length > 0) {
          return labs[0].Location.DisplayName;
        }
      } else {
        if (
          caseInfoDetails["ServiceProvider"].Location.AccountType !==
          undefined &&
          caseInfoDetails["ServiceProvider"].Location.AccountType ===
          "Laboratory"
        ) {
          return caseInfoDetails["ServiceProvider"].Location.DisplayName;
        }
      }
    }
  }

  filter(name: string): Filter[] {
    return this.searchOptions.filter(option =>
      option.name.toLowerCase().includes(name.toLowerCase()));
  }


  removeSearchValue(value: any): void {
    if (value.includes(':')) {
      const TrimValue = value.trim();
      const index = this.Filtervalue.findIndex(term => term.trim().toLowerCase() === TrimValue.toLowerCase());
      if (index !== -1) {
        this.Filtervalue.splice(index, 1);
        this.splitvalue = value.split(":")
        this.FormName = this.splitvalue[0].trim();

        // Find the form control key in a case-insensitive manner
        //     const formKey = Object.keys(this.searchForm.controls)
        // .find(key => key.toLowerCase() === this.FormName.toLowerCase());

        this.searchForm.get(this.FormName).patchValue("");
        this.responseData = this.FormName + ':';
        this.addOption = { name: this.responseData };
        // Check if the option is already present in searchOptions
        const optionExists = this.searchOptions.some(option => option.name.toLowerCase() === this.addOption.name.toLowerCase());
        if (!optionExists) {
          this.searchOptions.push(this.addOption);
        }
      }
    }
    else {
      const index = this.searchTermData.indexOf(value);
      if (index !== -1) {
        this.searchTermData.splice(index, 1);
      }
    }
    this.filteredOptions = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map(search => (search && typeof search === 'object') ? search.name : search),
        map((name: string) => name ? this.filter(name) : this.searchOptions.slice())
      );
      this.searchControl.reset();
  }


  addtoFilterForm(matchip:any): void {
    if (matchip.value.trim() !== '') {
      const parts = matchip.value.trim().split(':');
      if (parts.length > 1 && parts[1].trim() !== '') {
        const [inputKey, inputValue] = matchip.value.split(':').map(part => part.trim());
        if (!this.Filtervalue.includes(matchip.value.trim())) {
          this.Filtervalue.push(matchip.value.trim());
        }
        if (this.tomailInput) {
          this.tomailInput.nativeElement.value = null; // Display selected value in input field
        }
        // Find the form control key in a case-insensitive manner
        // const formKey = Object.keys(this.searchForm.controls)
        // .find(key => key.toLowerCase() === inputKey.toLowerCase());

        if (inputKey) {
          this.searchForm.get(inputKey).patchValue(inputValue); // Patch the form value
        }
        this.removeOptionWhenButtonCreated(inputKey);
      }
    }
  }
  selectedoption(event: MatAutocompleteSelectedEvent): void {
    this.tomailInput.nativeElement.value = event.option.value.name;
  }


  selectdeploymentEvent(item: any) {
    this.deploymentSelected = item;
  }

  onFocuseddeployment(event) {
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  cleareddeployment(event) {
    this.deploymentSelected = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  // toggleForm(){  
  //   this.showForm=!this.showForm;
  //   this.submitted=false;
  // }

  submitSearch() {
    let result: any;
    this.showDetailsCase = false
    this.oldFiltervalue = this.Filtervalue;
    this.responseData = '';
    this.searchTerm = [];
    this.submitted = true;
    this.CaseList = [];
    this.showForm = false;
    let encryptflag = false;
    if (this.menuTrigger && typeof this.menuTrigger.closeMenu === 'function') {
      this.menuTrigger.closeMenu();
    }
    //this.menuTrigger.closeMenu(); // Close the menu

    //3part search
      if (
        this.encryptedurl !== "" &&
        this.encryptedurl != undefined &&
        this.encryptedurl !== "{}"
      ) {
        encryptflag = true;
        this.searchcaseText = this.encryptedurl;
        this.service.updatessoStatus(true);
        result = {
          LSearch: this.searchcaseText,
          Encrypt: encryptflag,
          AgentId: this.encryptagentid,
          FilterFields: []
        };
      } 


    if (this.searchForm) {
      this.Filtervalue = this.ReadFromForm();
      this.searchTerm.forEach(searchTerm => {
        const [key, value] = searchTerm.split(':');
        const searchTermKey = key.trim();

        this.removeOptionWhenButtonCreated(key);
      });

      // Identify and handle missing values
      this.UpdateSerchOption(this.oldFiltervalue);

      if (this.deploymentSelected) {
        // Add the new element to searchTerm
        this.searchTerm.push(`DeploymentKey:${this.deploymentSelected}`);
      }
      this.searchTermData = this.searchTerm;

      let deploymentKeyExists = this.searchTerm.some(term => term.toLowerCase().includes('deploymentkey'));


      if (!encryptflag) {
        if (deploymentKeyExists && this.searchTerm != null && this.searchTerm.length > 1) {
          result = {
            LSearch: "",
            Encrypt: encryptflag,
            AgentId: "",
            FilterFields: []
          };

          this.searchFormKey.forEach((item: any, index: number) => {
            const [key, value] = this.searchfieldName[index].split(/:\s*|:\s*/);
            let FormKey = key.replace(/[\s#]/g, '');
            const searchTermItem = this.searchTerm.find(term => term.startsWith(key + ':'));
            if (searchTermItem) {
              const searchTermValue = searchTermItem.split(':')[1];
              result.FilterFields.push({
                [FormKey]: searchTermValue,
                fieldName: value
              });
            }
          });
          this.filterFieldsList = result.FilterFields;
        }
        else if (deploymentKeyExists == false) {
          // Warning for the case when searchTerm is not empty but deploymentKey is missing
          this.toastr.warning(
            "DeploymentKey is Mandatory",
            "",
            {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            }
          );
        }
        else {
          // Warning for the case when searchTerm is empty
          this.toastr.warning(
            "Search value is empty",
            "",
            {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            }
          );
        }
      }


    }
    if (result) {
      this.ngxUiLoaderService.start();
      this.service.Case360search(result).subscribe(
        (data) => {
          if (data.length > 0) {
            this.searchParameterInfo = false;
            data.forEach((element) => {
              if (element.casedata !== "") {
                element["caseInfoDetails"] = JSON.parse(element.casedata).Case;
              }
            });

            this.CaseList = data;
            if (data[0].ssoLaunch != undefined && data[0].ssoLaunch) {
              this.showCaseData(data[0]);
              var sessionObject1 = {
                userdata: {
                  FormattedDisplayName: data[0].userId,
                  userid: data[0].userId,
                },
              };
              sessionStorage.setItem(
                "sessionObjectlogin",
                JSON.stringify(sessionObject1)
              );
            }
            if(this.islabadmin){
              this.caseTabsList = this.caseTabsList.filter(tab => tab !== 'Messages' && tab !== 'Case Audit');
              this.showCaseData(data[0]);
            }
            this.ngxUiLoaderService.stop();
          } else {
            this.searchParameterInfo = true;
            this.caseInfo = "";
            this.caseInfoDetails = "";
            this.requisitionNumberData = {};
            this.searchDeployement = "";
            this.ngxUiLoaderService.stop();
            this.toastr.warning(
              "Case data could not be found. Please try again with different input.",
              "",
              {
                positionClass: "toast-bottom-right",
                timeOut: 4000,
              }
            );
          }
        },
        (error) => {
          this.ngxUiLoaderService.stop();
          this.service.copyableToastError(error.statusText,'Failed');
          this.searchDeployement = "";
        }
      );
    }

  }

  clearSearch() {

    this.tomailInput ? this.tomailInput.nativeElement.value = null : null;
    this.searchTermData = [];
    this.searchForm.reset();
    this.searchParameterInfo = true;
    this.caseInfoDetails = "";
    this.responseData = false;
    this.Filtervalue = [];
    this.CaseList = [];
    this.selectedDeploymentKey = [];
    this.searchTerm = [];
    this.searchControl.reset();

    this.filteredOptions = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map(search => (search && typeof search === 'object') ? search.name : search),
        map((name: string) => name ? this.filter(name) : this.searchOptionslist.slice())
      );
    this.searchOptions = JSON.parse(JSON.stringify(this.searchOptionslist));

    this.deploymentSelected = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  clearForm() {

    this.tomailInput ? this.tomailInput.nativeElement.value = null : null;
    this.searchTermData = [];
    this.searchForm.reset();
    this.searchParameterInfo = true;
    this.caseInfoDetails = "";
    this.responseData = false;
    this.Filtervalue = [];
    //this.CaseList = [];
    // this.selectedDeploymentKey=[];
    this.searchTerm = [];
    this.searchControl.reset();

    this.filteredOptions = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map(search => (search && typeof search === 'object') ? search.name : search),
        map((name: string) => name ? this.filter(name) : this.searchOptionslist.slice())
      );
    this.searchOptions = JSON.parse(JSON.stringify(this.searchOptionslist));

    //this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
  }

  notContainsKey(value: string): boolean {
    let containsOption = false;
    const parts = value.split(':');
    // Check if any value from searchOptionslist is included in the value
    for (const option of this.searchOptionslist) {
      if (value.includes(option.name)) {
        //if (value.toLowerCase().includes(option.name.toLowerCase())) {
        containsOption = true;
        break;
      }
    }
    // Check if value does not include "DeploymentKey" or "Encrypt" and includes searchOptions
    return !value.includes("DeploymentKey") && containsOption && parts.length > 1 && parts[1].trim() !== '';
  }

  submitOnEnter(event: KeyboardEvent) {
    this.oldSearchValue = this.Filtervalue;
    this.Filtervalue = [];
    this.searchTerm = [];

    // Submit form when Enter key is pressed
    if (event.key === 'Enter') {

      if (this.searchForm) {

        this.Filtervalue = this.ReadFromForm();
        this.searchTerm.forEach(searchTerm => {
          const [key, value] = searchTerm.split(':');
          const searchTermKey = key.trim();

          // Split each option in searchOptions and compare keys
          this.searchOptions.forEach((option, index) => {
            const optionKey = option.name.split(':')[0].trim();
            const optionKeyTrimmed = optionKey.trim();
            if (optionKeyTrimmed === searchTermKey) {
              this.searchOptions.splice(index, 1); // Remove matching option
            }
          });
        });
        // Identify and handle missing values
        this.UpdateSerchOption(this.oldSearchValue);

      }


      this.filteredOptions = this.searchControl.valueChanges
        .pipe(
          startWith(''),
          map(search => (search && typeof search === 'object') ? search.name : search),
          map((name: string) => name ? this.filter(name) : this.searchOptions.slice())
        );
    }

  }

  removeOptionWhenButtonCreated(value: string) {
    this.searchOptions.forEach((option, index) => {
      const optionKey = option.name.split(':')[0].trim();
      const optionKeyTrimmed = optionKey.trim();
      if (optionKeyTrimmed === value) {
        this.searchOptions.splice(index, 1); // Remove matching option
      }
    });

    this.filteredOptions = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map(search => (search && typeof search === 'object') ? search.name : search),
        map((name: string) => name ? this.filter(name) : this.searchOptions.slice())
      );

  }

  ReadFromForm() {

    Object.keys(this.searchForm.controls).forEach((FormControlName) => {
      const formControl = this.searchForm.get(FormControlName);
      this.formValue = formControl ? formControl.value : null;

      if (this.formValue !== null && this.formValue !== '') {
        this.searchTerm.push(`${FormControlName}:${this.formValue}`);
      }
    });
    return this.searchTerm;
  }
  loadedTabs = new Set<string>();
  tabComponentCache = new Map<string, { component: any, injector: Injector }>();
  nodataalertflag: boolean = false;
  selectedIndexTab: number = 0;
  onTabChanged(value) {
    this.selectedIndexTab= value.index;
    this.selectedTab = this.caseTabsList[value.index];
    if (this.selectedTab === 'Patient History') {
      this.nodataalertflag = true;
    }
    else{
      this.nodataalertflag = false;
    }
    this.loadedTabs.add(this.selectedTab);
  }
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
      this.modalRefsTracked = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
    this.UpdateSubscript.unsubscribe();
    this.service.CaseDataDetails = "";
    this.renderer.removeChild(document, this.el.nativeElement);// Cleanup: Remove the click event listener when the component is destroyed

  }

  UpdateSerchOption(oldSearchValue: string[]) {
    // Identify and handle missing values
    oldSearchValue.forEach(oldValue => {
      const [key, value] = oldValue.split(':');
      const formName = key.trim();
  
      // Check if the key exists in Filtervalue based on the key only (ignoring the value part)
      const isKeyPresent = this.Filtervalue.some(filterValue => {
        const [filterKey] = filterValue.split(':');
        return filterKey.trim() === formName;
      });
  
      // If the key is not present in Filtervalue and is not 'DeploymentKey', handle accordingly
      if (!isKeyPresent && formName && formName != 'DeploymentKey') {
        this.responseData = formName + ':'; 
        this.addOption = { name: this.responseData };
  
        // Check if the option is already present in searchOptions
        const optionExists = this.searchOptions.some(option => option.name.toLowerCase() === this.addOption.name.toLowerCase());
        
        if (!optionExists) {
          this.searchOptions.push(this.addOption);
        }
      }
    });
  }

   focusmatchipinput() {
    this.tomailInput.nativeElement.focus();
  }
  getTabComponent(i: string): { component: any, injector: Injector } {
    if (!this.tabComponentCache.has(i)) {
      const { component, data } = this.getComponent(i);
      const injector = this.createInjector(data);
      this.tabComponentCache.set(i, { component, injector });
    }
    return this.tabComponentCache.get(i)!;
  }
  getComponent(casetabIndex: string): { component: any, data: any } {
    switch (casetabIndex) {
      case 'Case Audit':
        this.auditData['islabadmin']=this.islabadmin;
        return { component: CaseauditComponent, data: this.auditData };
      case 'Case Info':
        this.caseInfo['islabadmin']=this.islabadmin || this.isadmin3;
        return { component: CaseinfoComponent, data: this.caseInfo };
      case 'Specimen Details':
        this.caseInfo['islabadmin']=this.islabadmin;
        return { component: CasespecimenComponent, data: this.caseInfo };
      case 'Messages':
        return { component: CasemessageComponent, data: this.requisitionNumberData };
      case 'Patient History':
        let obj={
          deployment:this.searchDeployement,
          CaseGuid:this.caseInfoDetails.CaseGUID,
          patientHistory:this.patientHistory,
          islabadmin:this.islabadmin
        }
        return { component: CasehistoryComponent, data: obj};
      case 'Other Info':
        this.caseInfoDetails['islabadmin']=this.islabadmin;
        return { component: OtherinfoComponent, data: this.caseInfoDetails };
      case 'Case Claims':
        this.caseInfoDetails['islabadmin']=this.islabadmin;
        return { component: CaseclaimComponent, data: this.caseInfoDetails };
    }
  }
  
  createInjector(data: any): Injector {
    return Injector.create({
      providers: [{ provide: 'caseData', useValue: data }],
      parent: this.injector,
    });
  }
    openAuditPopUp(caseGuid: any) {
  
      if (caseGuid != '') {
        const auditDataToModal = {
          id: caseGuid,
          context: "case",
        };

        const modalRef =   this.modalService.open(NewauditComponent,
          { windowClass: "myCustomModalClasscase360audit", backdrop: 'static', keyboard: false });
        modalRef.componentInstance.inputDataInModalComponent = auditDataToModal;
        this.trackModalRef(modalRef, "myCustomModalClasscase360audit");
        
        modalRef.result.then(() => {
          this.untrackModalRef(modalRef);
        }, (reason) => {
          this.untrackModalRef(modalRef);
        });
        
        // Add data attribute to identify the modal and backdrop
        setTimeout(() => {
          const modalElement = document.querySelector('.modal.show') as HTMLElement;
          if (modalElement) {
            modalElement.setAttribute('data-case360-modal', 'true');
          }
          const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
          if (backdrop) {
            backdrop.setAttribute('data-case360-modal', 'true');
          }
        }, 100);
        
        this.modalWasOpen = true;
      }
  
    }
  
  private hideModals() {
    // Get modals opened by THIS component (case360)
    const ownedModalClasses = this.modalRefsTracked && this.modalRefsTracked.length > 0
      ? this.modalRefsTracked.map(m => m.windowClass).filter(cls => cls && cls !== '')
      : [];
    
    // Include modals from child components (casemessage) - these use case360-specific classes
    const childComponentModalClasses = ['myCustomModalViewfilecase360', 'myCustomModalClasscase360hl7'];
    
    // Find modals opened by THIS component first
    let modalElements: NodeListOf<HTMLElement> = document.querySelectorAll('') as NodeListOf<HTMLElement>;
    if (ownedModalClasses.length > 0) {
      const selector = ownedModalClasses.map(cls => `.modal.${cls}`).join(', ');
      modalElements = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
    }
    
    // Also find modals from child components (casemessage) - check for data-case360-modal attribute
    let childModalElements = document.querySelectorAll('.modal[data-case360-modal="true"]') as NodeListOf<HTMLElement>;
    
    // If not found by data attribute, find by windowClass for child component modals
    if (childModalElements.length === 0) {
      const childSelector = childComponentModalClasses.map(cls => `.modal.${cls}`).join(', ');
      childModalElements = document.querySelectorAll(childSelector) as NodeListOf<HTMLElement>;
    }
    
    // Combine both: modals opened by THIS component and modals from child components
    const allModalElements: HTMLElement[] = [];
    modalElements.forEach(el => allModalElements.push(el));
    childModalElements.forEach(el => {
      // Only add if not already in the list (avoid duplicates)
      if (!allModalElements.includes(el)) {
        allModalElements.push(el);
      }
    });
    
    // If still not found, find any visible modal with case360 classes (for child components)
    if (allModalElements.length === 0) {
      const allModals = Array.from(document.querySelectorAll('.modal')) as HTMLElement[];
      for (let i = allModals.length - 1; i >= 0; i--) {
        const modal = allModals[i];
        const style = window.getComputedStyle(modal);
        // Check if modal is visible and has one of the child component case360 classes
        const hasChildClass = childComponentModalClasses.some(className => modal.classList.contains(className));
        if (hasChildClass && (modal.classList.contains('show') || (style.display !== 'none' && style.display !== ''))) {
          allModalElements.push(modal);
        }
      }
    }
    
    // Convert back to NodeListOf for consistency
    modalElements = allModalElements as any;
    
    // Hide ALL found modals (parent and nested) - includes modals from THIS component and child components
    if (modalElements.length > 0) {
      this.modalWasOpen = true;
      
      modalElements.forEach(modalElement => {
        const style = window.getComputedStyle(modalElement);
        // Only hide if it's actually visible
        if (modalElement.classList.contains('show') || (style.display !== 'none' && style.display !== '')) {
          // Add data attribute to identify this modal for later retrieval
          modalElement.setAttribute('data-case360-modal', 'true');
          // Hide the modal visually but keep it in DOM - use !important via setProperty
          // IMPORTANT: Keep the 'show' class to prevent Bootstrap from detecting this as dismissal
          modalElement.style.setProperty('display', 'none', 'important');
          // DO NOT remove 'show' class - this prevents Bootstrap from auto-dismissing
        }
      });
        
        // Also hide all backdrops and mark them
        const allBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
        allBackdrops.forEach(backdrop => {
          const backdropStyle = window.getComputedStyle(backdrop);
          if (backdropStyle.display !== 'none') {
            backdrop.setAttribute('data-case360-modal', 'true');
            backdrop.style.setProperty('display', 'none', 'important');
            // DO NOT remove 'show' class from backdrop - keep structure intact
          }
        });
        
        // Also hide any nested modals (nested modal scenario)
        // This includes hl7viewer opened from FileViewExplorerComponent (myCustomModalViewfilecase360)
        const nestedModalSelectors = [
          '.modal.myCustomModalClasscase360audit',  // Hl7viewer opened from FileViewExplorer
          '.modal.modalConfig',
          '.modal.modalConfigJSONagent',
          '.modal.myCustomModalClassaddvarule'
        ];
        
        nestedModalSelectors.forEach(selector => {
          let nestedModals = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
          nestedModals.forEach(nestedModal => {
            const nestedStyle = window.getComputedStyle(nestedModal);
            // Only hide if it's visible and not already marked as case360-modal
            // Check if there's a case360 modal open (FileViewExplorer or direct hl7viewer from casemessage)
            // If so, this myCustomModalClass is likely nested within it
            const hasCase360Modal = document.querySelector('.modal.myCustomModalViewfilecase360[data-case360-modal="true"]') !== null ||
                                   document.querySelector('.modal.myCustomModalClasscase360hl7[data-case360-modal="true"]') !== null ||
                                   document.querySelector('.modal.myCustomModalViewfilecase360.show') !== null ||
                                   document.querySelector('.modal.myCustomModalClasscase360hl7.show') !== null;
            if ((nestedModal.classList.contains('show') || (nestedStyle.display !== 'none' && nestedStyle.display !== '')) && 
                !nestedModal.hasAttribute('data-case360-modal') && hasCase360Modal) {
              nestedModal.setAttribute('data-case360-nested-modal', 'true');
              nestedModal.style.setProperty('display', 'none', 'important');
              // Keep 'show' class to prevent dismissal
            }
          });
        });
        
        // Also hide nested modal backdrops
        const nestedBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
        nestedBackdrops.forEach(nestedBackdrop => {
          const backdropStyle = window.getComputedStyle(nestedBackdrop);
          // Hide if visible and not already marked as case360-modal
          if (backdropStyle.display !== 'none' && !nestedBackdrop.hasAttribute('data-case360-modal')) {
            nestedBackdrop.setAttribute('data-case360-nested-modal', 'true');
            nestedBackdrop.style.setProperty('display', 'none', 'important');
          }
        });
        
        // Remove modal-open class from body to prevent scroll issues
        // Only remove if no other modals are active
        const hasOtherModals = document.querySelectorAll('.modal.show:not([data-case360-modal="true"]):not([data-case360-nested-modal="true"])').length > 0;
        if (!hasOtherModals) {
          document.body.classList.remove('modal-open');
        }
      } else {
        // No modal found - check if we have tracked refs or modals with data attribute
        this.modalWasOpen = (this.currentModalRefs && this.currentModalRefs.length > 0) || 
                           document.querySelectorAll('.modal[data-case360-modal="true"]').length > 0;
      }
  }

  private showModals() {
    // Only show if modal was open when tab became inactive
    if (this.modalWasOpen) {
      // Use a small delay to ensure DOM is ready
      setTimeout(() => {
        // Get modals opened by THIS component (case360)
        const ownedModalClasses = this.modalRefsTracked && this.modalRefsTracked.length > 0
          ? this.modalRefsTracked.map(m => m.windowClass).filter(cls => cls && cls !== '')
          : [];
        
        // Include modals from child components (casemessage) - these use case360-specific classes
        const childComponentModalClasses = ['myCustomModalViewfilecase360', 'myCustomModalClasscase360hl7'];
        
        // Find modals opened by THIS component first
        let modalElements: NodeListOf<HTMLElement> = document.querySelectorAll('') as NodeListOf<HTMLElement>;
        if (ownedModalClasses.length > 0) {
          const selector = ownedModalClasses.map(cls => `.modal.${cls}`).join(', ');
          modalElements = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
        }
        
        // Also find modals from child components (casemessage) - check for data-case360-modal attribute
        let childModalElements = document.querySelectorAll('.modal[data-case360-modal="true"]') as NodeListOf<HTMLElement>;
        
        // If not found by data attribute, try by windowClass for child component modals
        if (childModalElements.length === 0) {
          const childSelector = childComponentModalClasses.map(cls => `.modal.${cls}`).join(', ');
          childModalElements = document.querySelectorAll(childSelector) as NodeListOf<HTMLElement>;
        }
        
        // If still not found, find any modal with child component case360 classes (even if hidden)
        if (childModalElements.length === 0) {
          const allModals = Array.from(document.querySelectorAll('.modal')) as HTMLElement[];
          const foundModals: HTMLElement[] = [];
          for (let i = allModals.length - 1; i >= 0; i--) {
            const modal = allModals[i];
            const style = window.getComputedStyle(modal);
            const hasChildClass = childComponentModalClasses.some(className => modal.classList.contains(className));
            // Find modal with child component case360 class that is hidden (display: none) or doesn't have show class
            if (hasChildClass && (style.display === 'none' || !modal.classList.contains('show'))) {
              foundModals.push(modal);
              // Re-add data attribute if missing
              if (!modal.hasAttribute('data-case360-modal')) {
                modal.setAttribute('data-case360-modal', 'true');
              }
            }
          }
          childModalElements = foundModals as any;
        }
        
        // Combine both: modals opened by THIS component and modals from child components
        const allModalElements: HTMLElement[] = [];
        modalElements.forEach(el => allModalElements.push(el));
        childModalElements.forEach(el => {
          // Only add if not already in the list (avoid duplicates)
          if (!allModalElements.includes(el)) {
            allModalElements.push(el);
          }
        });
        
        // Convert back to NodeListOf for consistency
        modalElements = allModalElements as any;
        
        // Show ALL found modals (parent and nested) if we have tracked modals or modals with data attribute
        // This includes modals from THIS component and child components (casemessage)
        if (modalElements.length > 0 && ((this.currentModalRefs && this.currentModalRefs.length > 0) || 
            document.querySelectorAll('.modal[data-case360-modal="true"]').length > 0)) {
          modalElements.forEach(modalElement => {
            const style = window.getComputedStyle(modalElement);
            // Show if it was hidden (display: none)
            if (style.display === 'none' || !modalElement.classList.contains('show')) {
              // Show the modal again - override !important by setting with !important
              modalElement.style.setProperty('display', 'block', 'important');
              // Ensure show class is present
              if (!modalElement.classList.contains('show')) {
                modalElement.classList.add('show');
              }
            }
          });
          
          // Show all backdrops that were hidden (prefer those marked with data attribute)
          let backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-case360-modal="true"]')) as HTMLElement[];
          if (backdrops.length === 0) {
            backdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
          }
          
          backdrops.forEach(backdrop => {
            const backdropStyle = window.getComputedStyle(backdrop);
            if (backdropStyle.display === 'none') {
              backdrop.style.setProperty('display', 'block', 'important');
              if (!backdrop.classList.contains('show')) {
                backdrop.classList.add('show');
              }
            }
          });
          
          // Also show nested modals if they were open (nested modal scenario)
          // This includes hl7viewer opened from FileViewExplorerComponent (myCustomModalViewfilecase360)
          const nestedModalSelectors = [
            '.modal.myCustomModalClasscase360audit',  // Hl7viewer opened from FileViewExplorer
            '.modal.modalConfig',
            '.modal.modalConfigJSONagent',
            '.modal.myCustomModalClassaddvarule'
          ];
          
          nestedModalSelectors.forEach(selector => {
            let nestedModals = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
            nestedModals.forEach(nestedModal => {
              const nestedStyle = window.getComputedStyle(nestedModal);
              // Show if it was hidden and has the nested modal data attribute
              // Or if there's a case360 modal that should be shown (FileViewExplorer or direct hl7viewer from casemessage)
              const hasNestedAttribute = nestedModal.hasAttribute('data-case360-nested-modal');
              const hasCase360Modal = document.querySelector('.modal.myCustomModalViewfilecase360[data-case360-modal="true"]') !== null ||
                                     document.querySelector('.modal.myCustomModalClasscase360hl7[data-case360-modal="true"]') !== null ||
                                     document.querySelectorAll('.modal.myCustomModalViewfilecase360, .modal.myCustomModalClasscase360hl7').length > 0;
              if ((nestedStyle.display === 'none' || !nestedModal.classList.contains('show')) && 
                  !nestedModal.hasAttribute('data-case360-modal') && 
                  (hasNestedAttribute || hasCase360Modal)) {
                nestedModal.style.setProperty('display', 'block', 'important');
                if (!nestedModal.classList.contains('show')) {
                  nestedModal.classList.add('show');
                }
              }
            });
          });
          // Also show nested modal backdrops
          let nestedBackdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-case360-nested-modal="true"]')) as HTMLElement[];
          // If no backdrops found by data attribute, find all backdrops that aren't marked as case360-modal
          if (nestedBackdrops.length === 0) {
            const allBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
            nestedBackdrops = allBackdrops.filter(backdrop => !backdrop.hasAttribute('data-case360-modal'));
          }
          nestedBackdrops.forEach(nestedBackdrop => {
            const backdropStyle = window.getComputedStyle(nestedBackdrop);
            if (backdropStyle.display === 'none') {
              nestedBackdrop.style.setProperty('display', 'block', 'important');
              if (!nestedBackdrop.classList.contains('show')) {
                nestedBackdrop.classList.add('show');
              }
            }
          });
          
          // Re-add modal-open class to body
          document.body.classList.add('modal-open');
          
          // Verify modals are visible after a brief moment
          setTimeout(() => {
            // Double-check we still have tracked modals (user didn't close it)
            if (this.currentModalRefs && this.currentModalRefs.length > 0) {
              modalElements.forEach(modalElement => {
                const style = window.getComputedStyle(modalElement);
                if (style.display === 'none' || !modalElement.classList.contains('show')) {
                  // If Bootstrap hid it again, force show it
                  modalElement.style.setProperty('display', 'block', 'important');
                  modalElement.classList.add('show');
                }
              });
            }
          }, 200);
        } else {
          // If modal not found or no tracked modals, reset the flag
          if (!this.currentModalRefs || this.currentModalRefs.length === 0) {
            this.modalWasOpen = false;
          }
        }
      }, 150);
    }
  }
  
}

interface CaseInfo {
  CaseType: string;
  Services: string;
  AccessionNumber: string;
}
